import { GetSourceDataConfigurationSummaryCollectionByTrialCode, SourceDataConfigurationSummaryCollectionResponse } from '@/api/dtos';
import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';

const getData = (response?: SWRResponse<SourceDataConfigurationSummaryCollectionResponse, SourceDataConfigurationSummaryCollectionResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<SourceDataConfigurationSummaryCollectionResponse, SourceDataConfigurationSummaryCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useConfigurationSummaries = (trialCode?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return trialCode ? 
            () => new GetSourceDataConfigurationSummaryCollectionByTrialCode({ trialCode }) : 
            undefined;
    }, [trialCode]);

    return useGet(request, { getData, getError}, configuration);
};

export default useConfigurationSummaries;